import type { SVGProps } from 'react';

export function Icon3rdGenGroup(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 50"
      width="120"
      height="30"
      {...props}
    >
      <style>
        {`
          .text-3rd { font-family: 'Roboto', serif; font-size: 38px; font-weight: 700; fill: hsl(var(--primary)); }
          .text-gen { font-family: 'Roboto', sans-serif; font-size: 14px; font-weight: 700; fill: hsl(var(--foreground)); }
          .dark .text-3rd { fill: hsl(var(--primary-foreground)); }
          .dark .text-gen { fill: hsl(var(--foreground)); }
        `}
      </style>
      <text x="0" y="38" className="text-3rd">
        3rd Gen
      </text>
      <text x="140" y="28" className="text-gen">
        GROUP
      </text>
    </svg>
  );
}
